import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './CrawlingDashboard.css';

const CrawlingDashboard = () => {
  const navigate = useNavigate();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  // Mock data - 실제로는 API에서 가져올 데이터
  useEffect(() => {
    const mockData = [
      {
        id: 1,
        name: '뉴스 크롤링',
        url: 'https://news.example.com/{{category}}/{{page}}',
        frequency: '30분',
        status: '활성',
        lastRun: '2025-09-15 14:30',
        nextRun: '2025-09-15 15:00'
      },
      {
        id: 2,
        name: '주식 데이터 수집',
        url: 'https://api.stock.com/{{symbol}}/price',
        frequency: '5분',
        status: '비활성',
        lastRun: '2025-09-15 12:15',
        nextRun: '-'
      },
      {
        id: 3,
        name: '상품 정보 크롤링',
        url: 'https://shop.example.com/products/{{category}}',
        frequency: '1시간',
        status: '활성',
        lastRun: '2025-09-15 14:00',
        nextRun: '2025-09-15 15:00'
      }
    ];

    setTimeout(() => {
      setRequests(mockData);
      setLoading(false);
    }, 1000);
  }, []);

  const handleStatusToggle = (id) => {
    setRequests(prev =>
      prev.map(request =>
        request.id === id
          ? { ...request, status: request.status === '활성' ? '비활성' : '활성' }
          : request
      )
    );
  };

  const handleDelete = (id) => {
    if (window.confirm('정말로 이 크롤링 요청을 삭제하시겠습니까?')) {
      setRequests(prev => prev.filter(request => request.id !== id));
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>데이터를 불러오는 중...</p>
      </div>
    );
  }

  return (
    <div className="crawling-dashboard">
      {/* Header */}
      <div className="dashboard-header">
        <div>
          <h2 className="dashboard-title">크롤링 대시보드</h2>
          <p className="dashboard-subtitle">등록된 크롤링 요청들을 관리하고 모니터링하세요</p>
        </div>
        <button
          onClick={() => navigate('/crawling/new')}
          className="add-request-btn"
        >
          <span>➕</span>
          새 요청 추가
        </button>
      </div>

      {/* Stats */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-header">
            <span className="stat-title">총 요청 수</span>
            <span className="stat-icon">📊</span>
          </div>
          <div className="stat-value">{requests.length}</div>
        </div>

        <div className="stat-card">
          <div className="stat-header">
            <span className="stat-title">활성 요청</span>
            <span className="stat-icon">✅</span>
          </div>
          <div className="stat-value">
            {requests.filter(r => r.status === '활성').length}
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-header">
            <span className="stat-title">비활성 요청</span>
            <span className="stat-icon">⏸️</span>
          </div>
          <div className="stat-value">
            {requests.filter(r => r.status === '비활성').length}
          </div>
        </div>
      </div>

      {/* Requests Table */}
      <div className="requests-section">
        <div className="requests-header">
          <h3 className="requests-title">크롤링 요청 목록</h3>
        </div>

        {requests.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state-icon">📋</div>
            <h3 className="empty-state-title">크롤링 요청이 없습니다</h3>
            <p className="empty-state-description">새로운 크롤링 요청을 추가해보세요.</p>
            <button
              onClick={() => navigate('/crawling/new')}
              className="add-request-btn"
            >
              <span>➕</span>
              새 요청 추가
            </button>
          </div>
        ) : (
          <table className="requests-table">
            <thead>
              <tr>
                <th>요청명</th>
                <th>URL</th>
                <th>주기</th>
                <th>상태</th>
                <th>마지막 실행</th>
                <th>다음 실행</th>
                <th>작업</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((request) => (
                <tr key={request.id}>
                  <td>
                    <div className="request-name">{request.name}</div>
                  </td>
                  <td>
                    <div className="request-url" title={request.url}>
                      {request.url}
                    </div>
                  </td>
                  <td>
                    <span className="frequency-badge">{request.frequency}</span>
                  </td>
                  <td>
                    <div className="status-toggle">
                      <div
                        className={`toggle-switch ${request.status === '활성' ? 'active' : ''}`}
                        onClick={() => handleStatusToggle(request.id)}
                      >
                        <div className="toggle-slider"></div>
                      </div>
                      <span className={`status-text ${request.status === '활성' ? 'active' : 'inactive'}`}>
                        {request.status}
                      </span>
                    </div>
                  </td>
                  <td>{request.lastRun}</td>
                  <td>{request.nextRun}</td>
                  <td>
                    <div className="actions-cell">
                      <button
                        onClick={() => navigate(`/crawling/edit/${request.id}`)}
                        className="action-btn edit-btn"
                      >
                        ✏️ 수정
                      </button>
                      <button
                        onClick={() => handleDelete(request.id)}
                        className="action-btn delete-btn"
                      >
                        🗑️ 삭제
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default CrawlingDashboard;